module.exports = __webpack_public_path__ + "img/shirt-tank-top.b3557c13.svg";